<template lang="html">
	<div class="patrimonial-form">
		<template v-if="!isAnonymous">
			<div class="asterisk-container">
				Pour gagner du temps, vous pouvez télécharger directement votre dernier avis d’impôt sur le revenu
			</div>
			<div class="row start">
				<div class="btn btn-red ctn-icon light" @click="fileInput">
					<span class="icon-button-add"></span>
					Télécharger
					<input id="input-file" type="file" @change="setFile"/>
				</div>
				<div class="filename" v-if="file">
					{{ file.name }}
				</div>
			</div>
		</template>

		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label three">
					<label for="montant">Montant</label>
					<input type="text" name="montant" v-model="amount" v-on:keyup="parseAmount">
					<custom-select :items="currencies" :selected="currency" @change="currency=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label row" :class="{error: errors.has('nombre de parts')}">
					<label for="nombre de parts">Nombre de parts fiscales de votre foyer</label>
					<input type="text" v-validate="'decimal:1'" name="nombre de parts" v-model="nbFiscalParts" v-on:keyup="parsePartFiscale">
					<!-- <div class="label input-like">
						Nombre de parts fiscales de votre foyer
					</div> -->
					<!-- <div class="btn-add" @click="setFiscalParts(-1)">
						<span class="icon-form-less"></span>
					</div>
					<div class="btn-add" @click="setFiscalParts(1)">
						<span class="icon-form-plus"></span>
					</div>
					<div class="btn-add">
						{{ nbFiscalParts }}
					</div> -->
				</div>
				<div class="error-message">
					{{ errors.first('nombre de parts') }}
				</div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label" :class="{error: errors.has('prénom')}">
					<label for="montant">Pays de rattachement fiscal</label>
					<custom-select :object="true" :items="countries" :selected="countryForTaxes" @change="countryForTaxes=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
		</form>
	</div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import Country from '@/common/components/MyPatrimonialLandscape/data/Country'
import { mapGetters } from 'vuex'

export default {
	name: 'Taxes',
	components: {
		CustomSelect
	},
	data () {
		return {
			amount: null,
			currency: 'EUR',
			currencies: Currency,
			file: null,
			nbFiscalParts: 1,
			countries: Country,
			countryForTaxes: null
		}
	},
	mounted () {
		this.amount = this.estate.taxes.value || null
		this.currency = this.estate.taxes.cur || 'EUR'
		this.nbFiscalParts = this.estate.taxes.nbFiscalParts || 1

		const valueToCheck = this.estate.taxes.countryForTaxes || 'France'

		Country.forEach((country) => {
			if (country.type === valueToCheck) {
				this.countryForTaxes = country
			}
		})
	},
	methods: {
		validate () {
			return this.$validator.validate()
		},
		save () {
			if (this.file) this.$emit('fileupload', this.file)
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$emit('file', this.file)
						this.$store.dispatch('storePatrimonial', {
							name: 'TAXES',
							data: {
								value: this.amount,
								cur: this.currency,
								nbFiscalParts: this.nbFiscalParts,
								countryForTaxes: this.countryForTaxes.type
							},
							fromStart: false
						}).then(() => {
							resolve()
						})
					}
				})
			})
		},
		fileInput () {
			document.getElementById('input-file').click()
		},
		setFile (e) {
			console.log(e)
			this.file = e.target.files[0]
		},
		parseAmount () {
			if (!this.amount) {
				return
			}
			this.amount = this.amount.toString().replace(',', '.')
		},
		parsePartFiscale () {
			if (!this.nbFiscalParts) {
				return
			}

			this.nbFiscalParts = this.nbFiscalParts.toString().replace(',', '.')
		}
	},
	watch: {
		countryForTaxes (val) {
			console.log(val)
		}
	},
	computed: {
		...mapGetters({
			user: 'user',
			estate: 'estate',
			isAnonymous: 'isAnonymous'
		})
	},
	beforeDestroy () {
		this.save()
	}
}
</script>

<style lang="scss" scoped>
.btn {
	margin-bottom: 1rem;
}

#input-file {
	display: none;
}

.start {
	justify-content: flex-start;
	align-items: baseline;

	.filename {
		margin-left: 0.5rem;
		font-size: 0.8rem;
	}
}
</style>



// WEBPACK FOOTER //
// Taxes.vue?53b49d6e